export default __webpack_public_path__ + "static/media/3.6db2296e.png";